'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { getHighlightsForProductLine } from 'ui-addon-upgrades/_core/features/FeaturesUtils';
import { isUngatedForFeatureStore } from '../../../selectors/GatingSelectors';
import FeatureModalFS from './FeatureModalFS';
import FeatureModalSSAPI from './FeatureModalSSAPI';

const FeatureModalSplitter = props => {
  const isUngatedForFS = useSelector(isUngatedForFeatureStore);
  const highlightedProducts = getHighlightsForProductLine(props.productLine);

  if (isUngatedForFS) {
    return /*#__PURE__*/_jsx(FeatureModalFS, Object.assign({}, props, {
      highlightedProducts: highlightedProducts
    }));
  }

  return /*#__PURE__*/_jsx(FeatureModalSSAPI, Object.assign({}, props));
};

export default FeatureModalSplitter;